import Fetch, { pageInfo } from './fetch';

const summaryRequests = {

    /**
     * 传入需删除资源的id，返回是否删除成功
     */
    getSchoolSummaryTotal(str) {
        return Fetch({
            url: '/dormSummary/getSchoolSummaryTotal?' + str,
            method: 'get'
        });
    },
    getStudentBackSummaryTotal(str) {
        return Fetch({
            url: '/dormSummary/getStudentBackSummaryTotal?' + str,
            method: 'get'
        })
    },
    querySchoolCapmus() {
        return Fetch({
            url: '/school/querySchoolCapmus',
            method: 'get'
        })
    },
    getAllHouseBySchool(schoolId, campusId) {
        return Fetch({
            url: '/house/getAllHouseBySchool?schoolId=' + schoolId + "&schoolNum=" + campusId,
            method: 'get'
        })
    },
    getFloorListByHouseId(houseId) {
        return Fetch({
            url: '/floor/getFloorListByHouseId?houseId=' + houseId,
            method: 'get'
        })
    },
    getFloorDetailListByHouseId(campusId, houseId) {
        return Fetch({
            url: '/floor/getFloorDetailListByHouseId?campsId=' + campusId + '&houseId=' + houseId,
            method: 'get'
        })
    },
    getDormitoryStudentDistributions(str) {
        return Fetch({
            url: '/dormSummary/getDormitoryStudentDistributions?' + str,
            method: 'get'
        })
    },
    /**
     * 学校管理员-全部-饼图
     * @returns {*}
     */
    getCampusBackStatistics(str) {
        return Fetch({
            url: '/backStatistic/getCampusBackStatistics?' + str,
            method: 'get'
        })
    },
    /**
     * 学校管理员-全部-楼栋柱状图
     * @returns {Promise<Response>}
     */
    getAllCapmusAllHouseBackStatisticList() {
        return Fetch({
            url: '/backStatistic/getAllCapmusAllHouseBackStatisticList',
            method: 'get'
        })
    },
    /**
     * 学校管理员-校区-饼图和柱状图
     * @param campusId
     * @returns {*}
     */
    geCurrCampusAllHouseBackStatisList(campusId) {
        return Fetch({
            url: '/backStatistic/geCurrCampusAllHouseBackStatisList?campus_Id=' + campusId,
            method: 'get'
        })
    },
    /**
     *宿管员-楼栋-饼图
     * @param houseId
     * @returns {*}
     */
    getCurrCampusCurrHouseBackStatistic(houseId, campusId) {
        return Fetch({
            url: '/backStatistic/getCurrCampusCurrHouseBackStatistic?house_id=' + houseId + "&campusId=" + campusId,
            method: 'get'
        })
    },
    /**
     * 宿管员-楼栋-所有楼层柱状图
     * @param houseId
     * @returns {*}
     */
    getCurrHouseCurrAllFloorBackStatisticList(houseId, campusId) {
        return Fetch({
            url: '/backStatistic/getCurrHouseCurrAllFloorBackStatisticList?house_id=' + houseId + "&campusId=" + campusId,
            method: 'get'
        })
    },
    queryHouseByManagerUser() {
        return Fetch({
            url: '/house/queryHouseByManagerUser',
            method: 'get'
        })
    },
    // 根据ID得到学生资料
    getcurrentStudentInfo(studentId) {
        return Fetch({
            url: '/accommodationStuIInfo/queryAccommodationStuByUserId?' + studentId,
            method: 'get',
            headers: {
                responseType: 'arraybuffer'
            }
        });
    },
    qryMasterClasses() {
        return Fetch({
            url: '/classs/qryMasterClasses',
            method: 'get'
        })
    },
    queryHouseByClassesId(classesId, campusId) {
        return Fetch({
            url: '/dormSummary/queryHouseByClassesId?classesId=' + classesId + "&schoolNum=" + campusId,
            method: 'get'
        })
    },
    initDatavPage(str) {
        return Fetch({
            url: '/datavApi/initDatavPage?' + str,
            method: 'get'
        });
    }
}

export default summaryRequests;



// WEBPACK FOOTER //
// ./src/api/summary.js